/*
 * @Description: 
 * @Version: 1.0
 * @Author: tu
 * @Date: 2023-12-22 18:20:35
 * @LastEditors: tu
 * @LastEditTime: 2024-04-16 14:38:59
 * @FilePath: /clinic-home-web/src/components/pay-dialog/static-data.js
 */
/*
 * @Description: 
 * @Version: 1.0
 * @Author: tu
 * @Date: 2023-12-22 18:20:35
 * @LastEditors: tu
 * @LastEditTime: 2023-12-26 16:06:06
 * @FilePath: /clinic-home-web/src/components/pay-dialog/static-data.js
 */
import { REG_AMT } from '@/utils/validate/regExp';
import { optionsLabelGetter } from '@/utils/util.js';
import { filter } from 'underscore';

const amtPass = (rule, value, callback) => {
  if (value === '') {
    return callback(new Error('实收金额不能为空！'));
  }
  if (!REG_AMT.test(value)) {
    return callback(new Error('请填写正确的金额！'));
  }
  if (value < Number(this.total)) {
    return callback(new Error('实收金额不能小于付款金额！'));
  }
  callback();
}
const amtPassMul = (rule, value, callback) => {
  if (value === '') {
    return callback(new Error('实收金额不能为空！'));
  }
  if (!REG_AMT.test(value)) {
    return callback(new Error('请填写正确的金额！'));
  }
  callback();
}
const validatePayType = (rule, value, callback) => {
  if (value.length !== 2) {
    return callback(new Error('请选择两种支付方式！'));
  }
  callback();
}
export const formRules = {
  amt: [{ required: true, message: '请输入金额', trigger: 'blur' },],
  actualAmt: [{ validator: amtPass, trigger: 'change' },],
  actualAmtMul: [{ validator: amtPassMul, trigger: 'change' },],
  payType: [{ type: 'array', required: true, message: '请至少选择一种支付方式', trigger: 'change' },],
  payType: [{ validator: validatePayType, trigger: 'change' },],
  amt: [{ required: false, message: '请输入金额', trigger: 'blur' },],
  payType: [{ type: 'array', required: true, message: '请至少选择一种支付方式', trigger: 'change' },],
  debtorsName: [{ required: true, message: '请输入姓名', trigger: 'blur' },],
  // debtorsPhone: [{ required: true, validator: validatePhone, trigger: 'change' },],
}

export const filterOptions = (options, value, key = 'key', k = 'value') => {
  const option = options.find((u) => u[key] === value)
  return option ? option[k] : ''
}
export const nameList = [
  { key: '1', value: '张三' },
  { key: '2', value: '李四' },
]
export const genderList = [
  { key: '-1', value: '未知' },
  { key: '0', value: '女' },
  { key: '1', value: '男' },
]
export const mdtrtCertTypeList = [
  { key: '01', value: '电子凭证' },
  { key: '02', value: '身份证号' },
  { key: '03', value: '保障卡卡号' },
]
export const medTypeList = [
  { key: '11', value: '普通门诊' },
  { key: '14', value: '慢特病门诊' },
  { key: '9935', value: '独立门诊部个人帐户支付' },
]
export const diagTypeList = [
  { key: '1', value: '西医诊断' },
  { key: '2', value: '中医诊断' },
  // { key: '3', value: '中医主证诊断' },
]

export const diagTypeFilter = (value) => filterOptions(diagTypeList, value)

// 门诊挂号信息
export const registerInfoConfigList = [
  // { name: '姓名', key: 'psnName', label: '姓名', keyList: ['outpatientReg', 'psnName'], filter: (value) => filterOptions(nameList, value) },
  { name: '姓名', key: 'psnName', label: '姓名', keyList: ['outpatientReg', 'psnName'] },
  { name: '性别', key: 'gender', label: '性别', keyList: ['outpatientReg', 'gender'], filter: (value) => filterOptions(genderList, value) },
  { name: '出生日期', key: 'bir', label: '出生日期', keyList: ['outpatientReg', 'bir'] },
  { name: '年龄', key: 'age', label: '年龄', keyList: ['outpatientReg', 'age'] },
  { name: '民族', key: 'naty', label: '名族', keyList: ['outpatientReg', 'naty'] },
  // { name: '证件类型', key: 'psnCertType', label: '证件类型', keyList: ['outpatientReg', 'psnCertType'] },
  { name: '就诊凭证类型', key: 'mdtrtCertTypeLabel', label: '就诊凭证类型', keyList: ['outpatientReg', 'mdtrtCertTypeLabel'] },
  { name: '证件号码', key: 'certno', label: '证件号码', keyList: ['outpatientReg', 'certno'] },
  { name: '就诊凭证编号', key: 'mdtrtCertNo', label: '就诊凭证编号', keyList: ['outpatientReg', 'mdtrtCertNo'] },
  { name: '卡识别码', key: 'cardSn', label: '卡识别码', keyList: ['outpatientVisitsCompVO', 'outpatientVisits', 'cardSn'] },
  { name: '人员编号', key: 'psnNo', label: '人员编号', keyList: ['outpatientVisitsCompVO', 'outpatientVisits', 'psnNo'] },
  { name: '人员类别', key: 'psnType', label: '人员类别', keyList: ['outpatientReg', 'psnTypeLabel'] },
  { name: '险种类型', key: 'insutypeLabel', label: '险种类型', keyList: ['outpatientReg', 'insutypeLabel'] },
  // { name: '慢特病', key: '慢特病', label: '慢特病', keyList: ['outpatientReg', '慢特病'] },
  // { name: '手机号码', key: '手机号码', label: '手机号码', keyList: ['outpatientReg', '手机号码'] },
  { name: '门诊号', key: 'iptOtpNo', label: '门诊号', keyList: ['outpatientReg', 'iptOtpNo'] },
  { name: '科室名称', key: 'diagDept', label: '科室名称', keyList: ['outpatientReg', 'deptName'] },
  { name: '医生姓名', key: 'diseDorName', label: '医生姓名', keyList: ['outpatientReg', 'drName'] },
  { name: '挂号时间', key: 'diagTime', label: '挂号时间', keyList: ['outpatientReg', 'begntime'] },
]
// 门诊就诊信息
export const visitInfoConfigList = [
  { name: '就诊ID', key: 'mdtrtId', label: '就诊ID', keyList: ['outpatientVisitsCompVO', 'outpatientVisits', 'mdtrtId'] },
  { name: '医疗类别', key: 'medTypeLabel', label: '医疗类别', keyList: ['outpatientVisitsCompVO', 'outpatientVisits', 'medType'], filter: (value) => filterOptions(medTypeList, value) },
  { name: '病种名称', key: 'diseName', label: '病种名称', keyList: ['outpatientVisitsCompVO', 'outpatientVisits', 'diseName'] },
  { name: '就诊时间', key: 'begntime', label: '就诊时间', keyList: ['outpatientVisitsCompVO', 'outpatientVisits', 'begntime'] },
]
// 门诊费用信息
export const feeInfoConfigList = [
  { name: '费用名称', key: 'medChrgItemName', label: '费用名称', keyList: ['outpatientVisitsCompVO', 'outpatientVisitsFeeList', 'medChrgItemName'] },
  { name: '费用金额', key: 'detItemFeeSumamt', label: '费用金额', keyList: ['outpatientVisitsCompVO', 'outpatientVisitsFeeList', 'detItemFeeSumamt'] },
]

// 人员信息
export const personInfoConfigList = [
  { name: '费用名称', key: 'medChrgItemName', label: '费用名称', keyList: ['personInfoConfig', 'outpatientVisitsFeeList', 'medChrgItemName'] },
  { name: '费用名称', key: 'medChrgItemName', label: '费用名称', keyList: ['personInfoConfig', 'outpatientVisitsFeeList', 'medChrgItemName'] },
  { name: '费用名称', key: 'medChrgItemName', label: '费用名称', keyList: ['personInfoConfig', 'outpatientVisitsFeeList', 'medChrgItemName'] },
  { name: '费用名称', key: 'medChrgItemName', label: '费用名称', keyList: ['personInfoConfig', 'outpatientVisitsFeeList', 'medChrgItemName'] },
  { name: '费用名称', key: 'medChrgItemName', label: '费用名称', keyList: ['personInfoConfig', 'outpatientVisitsFeeList', 'medChrgItemName'] },
]